import { useTranslation } from 'react-i18next';
import { useSiteLang } from '../../layout/use-site-lang.js';
import { MockAppFrame } from '../mock-app-frame.jsx';
import { MockPhoneFrame } from '../mock-phone-frame.jsx';
import { CurrenciesCard } from '../currencies-card.jsx';
import { TransactionsCard } from '../transactions-card.jsx';
import { getMockRates } from '../mock-data/mock-data.js';
import { getMockCrossCurrencyTransactions } from '../mock-data/mock-transactions.js';

/**
 * Multi-currency use-case mockup: everyday currencies with auto-fetched
 * rates, the base-currency conversion note, and a mobile screenshot of a
 * cross-currency transactions feed.
 * @returns {JSX.Element}
 */
export function MultiCurrencyScreen() {
	const { t } = useTranslation();
	const lang = useSiteLang();
	return (
		<>
			<MockAppFrame>
				<CurrenciesCard currencies={getMockRates(lang)} />
			</MockAppFrame>
			<div className="use-case-callout card">
				<h3>{t('usecase.multi-currency.rates.title')}</h3>
				<p>{t('usecase.multi-currency.rates.body')}</p>
			</div>
			<div className="mock-row">
				<MockPhoneFrame>
					<TransactionsCard
						rows={getMockCrossCurrencyTransactions(lang)}
						columnKeys={['date', 'type', 'amount']}
					/>
				</MockPhoneFrame>
				<div className="use-case-callout card">
					<h3>{t('usecase.multi-currency.transactions.title')}</h3>
					<p>{t('usecase.multi-currency.transactions.body')}</p>
				</div>
			</div>
		</>
	);
}
